// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2648275c","796":"9d3c2d7c"}[chunkId] + ".chunk.js";
};